import React from "react";
import { Anchor, CalendarDays } from "lucide-react";

export default function SeoGrowthHero({ page }) {
  return (
    <section className="rounded-3xl border border-border bg-card p-6 shadow-xl md:p-10">
      <div className="max-w-4xl">
        <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-primary/10 px-4 py-2 text-sm font-bold text-primary">
          <Anchor className="h-4 w-4" /> {page.type}
        </div>
        <h1 className="text-balance font-heading text-4xl font-black md:text-6xl">{page.title}</h1>
        <p className="mt-5 text-pretty text-base leading-7 text-muted-foreground md:text-lg">{page.description}</p>
        <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-border bg-background px-4 py-2 text-sm font-bold text-muted-foreground">
          <CalendarDays className="h-4 w-4 text-primary" /> Last reviewed: {page.freshness.reviewed}
        </div>
      </div>
    </section>
  );
}